

export const initMenuNav = function () {
  const navBox = document.querySelector('[data-nav-menu]');
  const navListVisible = document.querySelector('[data-nav-menu-visible]');
  const navListHidden = document.querySelector('[data-nav-menu-hidden]');
  const navListBurger = document.querySelector('[data-nav-menu-burger]');
  let breakPointer = [];

  function updateNav() {
    let navWidth = navListBurger.classList.contains('is-hide') ? navBox.offsetWidth : navBox.offsetWidth - navListBurger.offsetWidth - 50;
    let navListVisibleWidth = navListVisible.offsetWidth;
    if (navListVisibleWidth > navWidth) {
      navBox.classList.add('is-collapse');
      if (navListBurger.classList.contains('is-hide')) {
        navListBurger.classList.remove('is-hide');
      }
      breakPointer.push(navListVisibleWidth);
      navListHidden.prepend(navListVisible.lastElementChild);
      updateNav();
    } else {
      if (navWidth > breakPointer[breakPointer.length - 1]) {
        breakPointer.pop();
        navListVisible.append(navListHidden.firstElementChild);
      }

      if (breakPointer.length < 1) {
        if (navBox.classList.contains('is-collapse')) {
          navBox.classList.remove('is-collapse');
        }
        navListBurger.classList.add('is-hide');
      }
    }
  }

  if (navBox) {
    updateNav();
  }

  // window.addEventListener('resize', updateNav);
};
